// @flow
import React from "react";
import SvgIconContainer from '../SvgIconContainer';

export default (
	{
		unit = 'em',
		...rest
	}: Object = {}) => (
	<SvgIconContainer viewBox="0 0 16 16" {...rest} unit={unit}>
		<g stroke="none" strokeWidth="1" fillRule="evenodd">
			<path d="M14.6057448,7.36920381 C14.254659,8.25240381 13.6583924,8.98078476
				12.9175162,9.60768 C11.381821,10.9071848 9.57366857,11.6840229
				7.52246857,11.977661 C6.43401143,12.1333943 5.35561143,12.1039848
				4.30098286,11.7818514 C4.0574781,11.7074895 3.82448762,11.6034133
				3.58662095,11.512899 C5.13404952,11.7495467 6.62585905,11.5348419
				8.09496381,11.1243276 C10.0308114,10.5830705 11.7985829,9.74543238
				13.3263543,8.50169905 C13.8240305,8.0965181 14.2641067,7.64288
				14.6205257,7.12265143 C14.6375924,7.09766095 14.6587733,7.07495619
				14.7104305,7.06459429 C14.6756876,7.16623238 14.6455162,7.26939429
				14.6057448,7.36920381"/>
			<path d="M2.14966857,8.50566095 C2.41968762,7.77956571 2.9038019,7.19960381
				3.46502095,6.68608 C5.08544,5.20402286 6.9886781,4.25103238
				9.10905905,3.71769905 C10.0413257,3.48318476 10.9897448,3.37834667
				11.951421,3.42741333 C12.5316876,3.45712762 13.0980876,3.55876571
				13.637059,3.79038476 C14.481859,4.15335619 14.8327924,4.84699429
				14.8215162,5.78748952 C14.81344,6.45369905 14.473021,6.97987048
				14.0271543,7.44295619 C13.3930971,8.10154667 12.619459,8.56326095
				11.8164114,8.97880381 C10.1386971,9.84722286 8.37062095,10.4412038
				6.49465905,10.6914133 C5.99439238,10.7581562 5.48833524,10.7816229
				5.14578286,10.8110324 C4.3550781,10.792899 3.72985905,10.7604419
				3.12734476,10.5570133 C2.12894476,10.2199467 1.78075429,9.49766095
				2.14966857,8.50566095" />
			<path d="M1.53252571,8.47000381 C1.52277333,8.48859429 1.50844952,8.50596571
				1.46852571,8.52105143 C1.47568762,8.46573714 1.47873524,8.41027048
				1.49077333,8.35526095 C1.65961143,7.57948952 2.10730667,6.88036571
				2.71439238,6.23289905 C3.95995429,4.90474667 5.55995429,3.94489905
				7.46761143,3.3268419 C8.48201143,2.99815619 9.52003048,2.82383238
				10.574659,2.90566095 C10.74944,2.91922286 10.9205638,2.94726095
				11.0935162,2.96874667 C9.47462095,3.09369905 8.00688762,3.61880381
				6.59934476,4.30253714 C5.13694476,5.01308952 3.83119238,5.87480381
				2.73801143,6.93232762 C2.2478019,7.40638476 1.82509714,7.91076571
				1.53252571,8.47000381" />
			<path d="M15.578481,8.07957352 C15.0671285,9.29731327 14.2354666,10.3216594
				13.0854874,11.2395116 C11.3327605,12.6383228 9.32160321,13.4769528
				7.07542417,13.7624073 C6.75747643,13.8027654 6.50011536,13.8177125
				5.95046368,13.8367938 C5.68892609,13.8458702 5.57881871,13.8502208
				5.38239638,13.8568297 C4.00416822,13.749385 2.90639081,13.4403047
				1.93816531,12.8091508 C0.814430151,12.0767066 0.15199054,11.0507871
				0.0217848147,9.74559673 C-0.0712363854,8.81387072 0.135635648,7.90730213
				0.604175268,6.98894694 C1.21312194,5.79488157 2.11319193,4.80111461
				3.30913969,3.93050539 C4.91486611,2.76161793 6.70294097,2.03339312
				8.65565526,1.75143579 C10.4190148,1.4967687 11.9603934,1.64582045
				13.3793856,2.29513314 C14.4590723,2.78918866 15.2361692,3.52302003
				15.6711394,4.54795316 C16.1508151,5.67781499 16.0936846,6.85187515
				15.578481,8.07957352 Z M15.2365201,4.74414897 L14.8018864,4.94031093
				C14.4689247,4.15572503 13.8700628,3.5902008 12.9945393,3.18956863
				C11.753211,2.62155269 10.3871426,2.48945349 8.78724117,2.7205137
				C6.98393287,2.98089793 5.33839479,3.65107213 3.85634102,4.72993217
				C2.77587181,5.51647695 1.97786476,6.39755626 1.44394547,7.44450266
				C1.05719645,8.20254521 0.893316071,8.92071288 0.965668689,9.64541669
				C1.06484412,10.6395575 1.55851023,11.4040976 2.44513713,11.981996
				C3.26500368,12.5164397 4.21787006,12.7847202 5.39336524,12.8803575
				C5.5370852,12.8726013 5.65111581,12.8680957 5.90627957,12.8592405
				C6.44036464,12.8406997 6.67855265,12.8268662 6.95943895,12.7912124
				C9.0382986,12.5270216 10.8886008,11.7554663 12.5047441,10.4656594
				C13.5359973,9.64256794 14.2653654,8.74421564 14.7077052,7.6908234
				C15.1244063,6.69785037 15.1679671,5.80258319 14.8019151,4.94037865
				L15.2365201,4.74414897 Z" fillRule="nonzero" />
		</g>
	</SvgIconContainer>
);


// WEBPACK FOOTER //
// ./src/components/Icons/Ball.js